/* ss-cerca.js — ricerca che perdona gli errori di battitura.
   Tre livelli: suggerimenti nativi di Shopify, dizionario di errori tipici,
   e confronto a somiglianza sui nomi veri dei prodotti. */
(function () {
  var box = document.getElementById('ss-cerca');
  if (!box) return;
  if (box.parentNode !== document.body) document.body.appendChild(box);

  var inp   = box.querySelector('[data-src-in]');
  var lista = box.querySelector('[data-src-ris]');
  var hint  = box.querySelector('[data-src-hint]');
  var paro  = box.querySelector('[data-src-paro]');
  var tutti = box.querySelector('[data-src-tutti]');
  var indice = null, timer = null, ultimo = '';

  /* --- normalizzazione: via accenti, doppie e punteggiatura --- */
  function norm(s) {
    return (s || '').toLowerCase()
      .normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9\s]/g, ' ')
      .replace(/\s+/g, ' ').trim();
  }
  function radice(s) { return norm(s).replace(/(.)\1+/g, '$1'); }

  /* --- errori che la gente fa davvero su questo catalogo --- */
  var DIZ = {
    muscola:'mussola', mussolina:'mussola', musola:'mussola', mussole:'mussola',
    garza:'mussola', 'doppia garza':'mussola',
    piche:'piquet', picche:'piquet', pique:'piquet', pichet:'piquet', piquet:'piquet',
    zenetto:'zainetto', zainetti:'zainetto', zaino:'zainetto',
    spungna:'spugna', spugne:'spugna', 'nido d ape':'spugna nido',
    cottone:'cotone', cotton:'cotone', cotoni:'cotone',
    tule:'tulle', tull:'tulle',
    veluto:'velluto', vellutto:'velluto',
    asciugamano:'asciugamani', sciugamani:'asciugamani',
    bavaglino:'spugna', bavaglini:'spugna',
    corredino:'mussola', fiocco:'tulle', 'fiocco nascita':'tulle',
    bomboniera:'juta', bomboniere:'juta',
    panama:'panama', pannama:'panama',
    borsa:'borsa', borse:'borsa', sacchetto:'sacca', sacchetti:'sacca'
  };
  function correggi(q) {
    var n = norm(q);
    if (DIZ[n]) return DIZ[n];
    var parole = n.split(' ').map(function (p) { return DIZ[p] || p; });
    return parole.join(' ');
  }

  /* --- distanza fra due parole, per capire cosa intendeva --- */
  function dist(a, b) {
    if (a === b) return 0;
    var m = a.length, n = b.length;
    if (!m || !n) return Math.max(m, n);
    var pre = new Array(n + 1), cur = new Array(n + 1), i, j;
    for (j = 0; j <= n; j++) pre[j] = j;
    for (i = 1; i <= m; i++) {
      cur[0] = i;
      for (j = 1; j <= n; j++) {
        cur[j] = Math.min(pre[j] + 1, cur[j - 1] + 1, pre[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
      }
      for (j = 0; j <= n; j++) pre[j] = cur[j];
    }
    return pre[n];
  }

  function punteggio(titolo, q) {
    var t = norm(titolo), tr = radice(titolo), qr = radice(q);
    if (t.indexOf(q) === 0) return 100;
    if (t.indexOf(q) > -1) return 85;
    if (tr.indexOf(qr) > -1) return 75;
    var pt = t.split(' '), pq = q.split(' '), best = 0;
    pq.forEach(function (w) {
      if (w.length < 3) return;
      pt.forEach(function (x) {
        if (x.length < 3) return;
        var d = dist(w, x), soglia = w.length <= 5 ? 1 : (w.length <= 8 ? 2 : 3);
        if (d <= soglia) best = Math.max(best, 70 - d * 8);
        else if (x.indexOf(w.slice(0, Math.max(3, w.length - 2))) === 0) best = Math.max(best, 55);
      });
    });
    return best;
  }

  function caricaIndice() {
    if (indice) return Promise.resolve(indice);
    var cache = null;
    try { cache = sessionStorage.getItem('ssIndice'); } catch (e) {}
    if (cache) { try { indice = JSON.parse(cache); return Promise.resolve(indice); } catch (e) {} }
    return fetch('/collections/all?view=indice')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        indice = d;
        try { sessionStorage.setItem('ssIndice', JSON.stringify(d)); } catch (e) {}
        return d;
      }).catch(function () { indice = []; return indice; });
  }

  function eur(c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; }
  function prezzo(p) {
    if (p.m === 'pezzo') return eur(p.p);
    return eur(Math.round(p.p / (p.s || 0.5))) + '/m';
  }

  function disegna(ris, q, corretto) {
    if (!ris.length) {
      lista.innerHTML = '<p class="ss-src2__zero">Non abbiamo trovato niente per “' + q + '”. Prova con una parola sola, tipo mussola o spugna.</p>';
      tutti.hidden = true; hint.hidden = true;
      return;
    }
    hint.hidden = !corretto;
    if (corretto) hint.innerHTML = 'Forse cercavi <b>' + corretto + '</b>';
    lista.innerHTML = ris.slice(0, 8).map(function (p) {
      return '<a class="ss-src2__r" href="' + p.u + '">' +
        '<span class="ss-src2__f">' + (p.i ? '<img src="' + p.i + '" alt="">' : '') + '</span>' +
        '<span class="ss-src2__n"><b>' + p.t + '</b><em>' + (p.a ? 'Disponibile' : 'Esaurito') + '</em></span>' +
        '<span class="ss-src2__pr">' + prezzo(p) + '</span></a>';
    }).join('');
    tutti.hidden = false;
    tutti.href = '/search?q=' + encodeURIComponent(corretto || q) + '&type=product';
    tutti.textContent = 'Vedi tutti i risultati';
  }

  function cerca(q) {
    if (!q || q.length < 2) { lista.innerHTML = ''; tutti.hidden = true; hint.hidden = true; return; }
    caricaIndice().then(function (idx) {
      var qn = norm(q);
      var diretti = idx.map(function (p) { return { p: p, s: punteggio(p.t, qn) }; })
                       .filter(function (x) { return x.s > 0; });
      var corretto = null;
      if (diretti.length < 3) {
        var c = correggi(q);
        if (c !== qn) {
          var alt = idx.map(function (p) { return { p: p, s: punteggio(p.t, c) }; })
                       .filter(function (x) { return x.s > 0; });
          if (alt.length > diretti.length) { diretti = alt; corretto = c; }
        }
      }
      diretti.sort(function (a, b) {
        if (b.s !== a.s) return b.s - a.s;
        if (a.p.a !== b.p.a) return a.p.a ? -1 : 1;
        return a.p.t.length - b.p.t.length;
      });
      disegna(diretti.map(function (x) { return x.p; }), q, corretto);
    });
  }

  inp.addEventListener('input', function () {
    var q = inp.value.trim();
    if (q === ultimo) return;
    ultimo = q;
    clearTimeout(timer);
    timer = setTimeout(function () { cerca(q); }, 160);
  });
  inp.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      var q = inp.value.trim();
      if (q) location.href = '/search?q=' + encodeURIComponent(q) + '&type=product';
    }
  });
  if (paro) paro.addEventListener('click', function (e) {
    var s = e.target.closest('span[data-q]');
    if (!s) return;
    inp.value = s.getAttribute('data-q'); ultimo = ''; inp.dispatchEvent(new Event('input')); inp.focus();
  });

  var ultimoFuoco = null;
  function apri() {
    ultimoFuoco = document.activeElement;
    box.hidden = false;
    requestAnimationFrame(function () { box.classList.add('is-open'); });
    document.documentElement.style.overflow = 'hidden';
    setTimeout(function () { inp.focus(); }, 120);
    caricaIndice();
  }
  function chiudi() {
    box.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    setTimeout(function () { box.hidden = true; }, 280);
    if (ultimoFuoco) ultimoFuoco.focus();
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('a[href*="/search"], [data-src-apri]') : null;
    if (t && !t.hasAttribute('data-src-no')) { e.preventDefault(); apri(); }
    if (e.target.closest && e.target.closest('[data-src-chiudi]')) chiudi();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !box.hidden) chiudi(); });
})();
